import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { updateStaffEmploymentInfo } from "../../../redux/slice/staff/staffSlice";
import useInputChange from "../../../utils/hooks/useInputChange";
import { isEmptyObject } from "../../../utils/validators/validators";
import Form from "../../form/Form";
import { useDispatch } from "react-redux/";
import Select from "../../form/select/Select";
import { flashMessage } from "../../../utils/flash";

const AtEmployment = () => {
  const { offices } = useSelector((state) => state.office.offices);
  const [hasEditStaff, setHasEditStaff] = useState();
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState({});
  const [employmentInfo, setEmploymentInfo] = useState({});

  const dispatch = useDispatch();

  // fetch records from redux state
  const { employment_information } = useSelector(
    (state) => state?.staff.staff_information
  );
  const { user_permissions } = useSelector((state) => state.auth?.user);

  const [officeValueError, setOfficeValueError] = useState("");

  // declare input fields variables
  const [officeValue, setOfficeValue] = useState({
    value: employmentInfo[0]?.office_id,
    label: employmentInfo[0]?.office_name,
  });
  const [staffInputData, setStaffInputData] = useState({
    department: "",
    designation: "",
    unit: "",
    staff_id: "",
    office_id: "",
    office_name: "",
  });

  // Update Personal Info
  const handleSubmit = () => {
    if (!officeValue?.value) {
      flashMessage("error", "Office At Employment is required");
      return;
    }

    let payload = {
      ...staffInputData,
      office_id: officeValue?.value,
      office_name: officeValue?.label,
    };

    if (isEmptyObject(error)) {
      dispatch(updateStaffEmploymentInfo(payload));
    }
  };

  const resetOnClose = () => {
    setStaffInputData({
      ...staffInputData,
      department: employmentInfo[0]?.department,
      designation: employmentInfo[0]?.designation,
      unit: employmentInfo[0]?.unit,
      id: employmentInfo[0]?.id,
      staff_id: employmentInfo[0]?.staff_id,
      office_id: employmentInfo[0]?.office_id,
      office_name: employmentInfo[0]?.office_name,
    });
  };
  // Custom hook for input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  const handleOfficeChange = (value) => {
    if (!value) {
      setOfficeValueError("Office at employment is required");
    } else {
      setOfficeValueError("");
    }
    setOfficeValue(value);
  };

  useEffect(() => {
    setEmploymentInfo(employment_information);
    if (employment_information) {
      setStaffInputData({
        ...staffInputData,
        department: employmentInfo[0]?.department,
        designation: employmentInfo[0]?.designation,
        unit: employmentInfo[0]?.unit,
        id: employmentInfo[0]?.id,
        staff_id: employmentInfo[0]?.staff_id,
        office_id: employmentInfo[0]?.office_id,
        office_name: employmentInfo[0]?.office_name,
      });
      setOfficeValue({
        value: employmentInfo[0]?.office_id,
        label: employmentInfo[0]?.office_name,
      });
    }
  }, [employment_information, editing]);

  useEffect(() => {
    setHasEditStaff(
      user_permissions?.some((permission) => permission.name === "edit staff")
    );
  }, [user_permissions]);

  return (
    <>
      <Form
        setError={setError}
        submitHandler={handleSubmit}
        values={staffInputData}
      >
        <div className='row shadow-lg p-2 py-3'>
          <h4 className='fw-normal text-primary '>At Employment</h4>
          <div className='col-xs-6 col-sm-6 col-md-4'>
            <h5>Designation At Employment</h5>
            {!editing && <p>{employment_information[0]?.designation}</p>}
            {editing && (
              <input
                textname='designation'
                className={`form-control form-control-sm update-input ${
                  error.designation && "is-invalid"
                }`}
                type='text'
                name='designation'
                value={input.designation}
                onChange={handleChange}
                id='designation'
                placeholder='designation at employment'
              />
            )}
            {error.designation && (
              <span className='invalid-feedback'>{error.designation}</span>
            )}
          </div>
          <div className='col-xs-6 col-sm-6 col-md-4'>
            <h5>Department At Employment</h5>
            {!editing && <p>{employment_information[0]?.department}</p>}
            {editing && (
              <input
                textname='department'
                className={`form-control form-control-sm update-input ${
                  error.department && "is-invalid"
                }`}
                type='text'
                name='department'
                value={input.department}
                onChange={handleChange}
                id='department'
                placeholder='department at employment'
              />
            )}
            {error.department && (
              <span className='invalid-feedback'>{error.department}</span>
            )}
          </div>
          <div className=' col-sm-6 col-md-4'>
            <h5>Unit At Employment</h5>
            {!editing && <p>{employment_information[0]?.unit}</p>}
            {editing && (
              <input
                textname='unit'
                className={`form-control form-control-sm update-input `}
                type='text'
                name='unit'
                validate='false'
                value={input.unit}
                onChange={handleChange}
                id='unit'
                placeholder='unit at employment'
              />
            )}
          </div>
          <div className=' col-sm-6 col-md-4 mt-2'>
            <h5>Office</h5>
            {!editing && (
              <p className='text-capitalize'>
                {employment_information[0]?.office_name}
              </p>
            )}
            {editing && (
              <>
                <Select
                  onBlur={() => {
                    if (!officeValue?.value) {
                      setOfficeValueError("Office at employment is required");
                    } else {
                      setOfficeValueError("");
                    }
                  }}
                  name='policy_id'
                  data={offices?.map((office) => ({
                    value: office.id,
                    label: office.office_name,
                  }))}
                  value={parseInt(officeValue?.value)}
                  onChange={(selectedOption) =>
                    handleOfficeChange(selectedOption)
                  }
                />
                {officeValueError && (
                  <p className='mb-0 text-danger'>{officeValueError}</p>
                )}
              </>
            )}
          </div>
          <div className=' col-sm-6 col-md-4 mt-2'>
            <h5>Staff ID</h5>
            {!editing && <p>{employment_information[0]?.staff_id}</p>}
            {editing && (
              <input
                textname='unit'
                className={`form-control form-control-sm update-input `}
                type='text'
                name='staff_id'
                validate='false'
                disabled
                value={input.staff_id}
                onChange={handleChange}
                id='staff_id'
                placeholder='Staff ID'
              />
            )}
          </div>
        </div>
        {hasEditStaff && (
          <div className='d-flex float-end '>
            <div>
              <a
                className={`btn btn-${
                  editing ? "warning" : "info"
                } btn-sm mt-3 px-4 text-white`}
                onClick={() => {
                  setEditing(editing ? false : true);
                  resetOnClose();
                }}
              >
                {editing ? "Close" : "Edit"}
              </a>
              {editing && (
                <button className='btn btn-success ms-2 btn-sm mt-3 px-4'>
                  Save
                </button>
              )}
            </div>
          </div>
        )}
      </Form>
    </>
  );
};

export default AtEmployment;
